import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { actionCreators } from "../actions/tagDataAction";
import { actionCreators as filterActions } from "../actions/searchBarActions";
import axios from "axios";
import FilterInfoBar from "../components/FilterInfoBar/FilterInfoBar";
import PageContent from "../components/PageContent/PageContent.js";
import PageLayout from "../components/PageLayout/PageLayout.js";
import {withRouter} from 'react-router-dom';
import ReactGA from 'react-ga';
import APPCONST from '../constants/constants';
// import Survey from '../components/Survey/survey'

ReactGA.initialize(APPCONST.googleAnalyticsCode);

class FilterPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            offset: 0,
            data: [],
            TotalCount: undefined,
            newTags: [],
        }
    }

    componentDidMount() {
        this.getData(0);
        //Google analytics
        ReactGA.pageview(window.location.pathname + window.location.search);
    }

    componentWillUnmount(){
        this.props.removeAllFilters();
        this.props.refreshFilterTags();
    }

    componentDidUpdate(prevProps, prevState) {
        if(this.props.filterData.filters !== prevProps.filterData.filters ||
            this.props.filterData.searchQuery !== prevProps.filterData.searchQuery)
        {  
            let newTotalCount = undefined;

            if (prevState.TotalCount === 0) {
                newTotalCount = 0;
            }
            this.setState({
                data: [],
                TotalCount: newTotalCount,
                offset: 0
            });

            this.getData(0);
        }
    }

    getMoreResults() {
        this.setState(prevState => { return { offset: prevState.offset + 1 } });
        this.getData(1);
    }

    getData(o) {
        axios
            .get(window.global.content_hub.API + "/api/filtered_content", {
                params: {
                    region: window.global.content_hub.region,
                    tags: this.props.filterData.filters,
                    searchtxt: this.props.filterData.searchQuery,
                    offsetby: o === 0 ? 0 : this.state.offset + o
                },
            })
            .then((res) => {
                if (res.data.TotalCount === 0) {
                    this.setState((state) => {
                        return {
                            TotalCount: res.data.TotalCount,
                        };
                    });
                    //resolve();
                }
                if (res.data.tags) {

                    //Should always exist, error handling to do.
                    this.props.updateFilterTags(res.data.tags);
                }
                this.setState((state) => {
                    return {
                        TotalCount: res.data.TotalCount,
                        data: this.state.data.length === 0 
                        || this.state.offset === 0 ? res.data.content : state.data.concat(res.data.content),
                    };
                });
            })
            .catch((err) => {
                console.log(err);
            });
    }

    generateLayout() {
        let layoutArray = [];
        if (this.state.data){
            layoutArray = this.state.data.map((c) => (
                <PageContent
                    key={c.ID}
                    data={c}
                    open={() =>  this.props.history.push('/pages/content/'+c.ID) }
                />
            ));
        }
        return layoutArray;
    }

    checkMoreResults() {
        if (this.state.data && this.state.TotalCount > this.state.data.length) {
            const styles = {
                color: "#333",
                border: "none",
                cursor: "pointer",
                fontSize: "16Px",
                fontWeight: "bold",
                background: "border-box"
            };
            return (
                <div
                    style={{
                        width: "100%",
                        "textAlign": "center",
                        marginBottom: "20px",
                    }}
                >
                    <button
                        style={styles}
                        type="button"
                        onClick={() => {
                            this.getMoreResults();
                        }}
                    >
                        Load More
          </button>
                </div>
            );
        }
    }


    render() {
        return (
            <React.Fragment>
				<FilterInfoBar
					page_router={this.props.page_router}
					results={this.state.TotalCount}
					length={this.state.data ? this.state.data.length : 0}
					filters={this.props.filterData.filters}
				/>
				<PageLayout layout="FILTER1" sort={false}>
					{this.generateLayout()}
				</PageLayout>
				<br />
				{this.checkMoreResults()}
                {/* <Survey></Survey> */}
			</React.Fragment>
        );
    }

}



export default connect(
    (state) => {
        const { tagData, filterData } = state;
        return { tagData, filterData };
    },
    (dispatch) =>
        bindActionCreators({ ...actionCreators, ...filterActions }, dispatch)
)(withRouter(FilterPage));
